<link rel="preload" as="image" href="assets/Carousel/image1.webp" type="image/webp" />
<link rel="preload" as="image" href="assets/Carousel/image3.webp" type="image/webp" />
<link rel="preload" as="image" href="assets/Carousel/image2.webp" type="image/webp" />

<div class="slides" *ngIf="slides.length > 0; else loadingPlaceholder">

  <div class="slide-wrapper">
    <!-- Blurred backdrop for wide screens (>=1440px) -->
    @if (slides[currentSlide]; as activeSlide) {
      <img
        [src]="activeSlide.url"
        [style.object-position]="activeSlide.centerX + ' ' + activeSlide.centerY"
        class="slide-backdrop"
        alt=""
        aria-hidden="true"
      />
      <div class="slide-fade slide-fade--left"></div>
      <div class="slide-fade slide-fade--right"></div>
    }

    <picture *ngFor="let slide of slides; let i = index">
      <source
        [srcset]="slide.url"
        type="image/webp"
      />
      <img
        [ngSrc]="slide.url"
        [alt]="slide.alt || 'Slide image'"
        [style.object-position]="slide.centerX + ' ' + slide.centerY"
        [class.visible]="i === currentSlide && !hidden"
        [class.hidden]="i !== currentSlide || hidden"
        fill
        priority
        class="slide-image"
        decoding="async"
      />
    </picture>
  </div>


  @if (indicatorsVisible) {
    <div id="indicators" [style.--transition-speed.ms]="animationSpeed / 2">
      @for(slide of slides; track $index; ){
        <div
          (click)="jumpToSlide($index)"
          class="indicator"
          [ngClass]="{ active: $index == currentSlide }"
        ></div>
      }
    </div>
  }

  <button (click)="next()" class="nextButton">
    <mat-icon>navigate_next</mat-icon>
  </button>
  <button (click)="previous()" class="previousButton">
    <mat-icon>navigate_before</mat-icon>
  </button>
</div>

<ng-template #loadingPlaceholder>
  <p>Loading slides...</p>
</ng-template>
